<div class="device-module-container mb-2 mb-sm-3 mb-lg-4 mb-xl-5" *ngIf="vm">
  <img osnSharedUseAsPicture [src]="vm.backgroundImageUrl" class="background-image" [imgQuery]="imgQuery" alt="" />
  <div class="content-container">
    <h2 class="module-title" [innerHTML]="vm.headlineText | lineBreak"></h2>
    <h3 class="module-subtitle">{{ vm.descriptionText }}</h3>
    <div class="spacer"></div>
    <div>
      <osn-shared-marketing-action-button
        [onMarketingLandingPage]="false"
        [actionButton]="vm.primaryButton"
        *ngIf="vm.primaryButton"
        data-testid="MarketingDeviceModule.actionButton"
        (measureClick)="onMarketingDeviceModuleButtonClick()"
        [secondaryStyle]="vm.primaryButton.action === 'SignUp'"
        [buttonText]="primaryButtonText"
      >
      </osn-shared-marketing-action-button>
    </div>
  </div>
</div>
